import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBgtNnpg6TmNq4HujQeY6lSGNar44hTr9k",
  authDomain: "accessshield-ai.firebaseapp.com",
  projectId: "accessshield-ai",
  storageBucket: "accessshield-ai.firebasestorage.app",
  messagingSenderId: "477330267927",
  appId: "1:477330267927:web:4316766577c1be8b29e152",
  measurementId: "G-HYGL0KD450"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
// Explicitly set region to us-central1 where functions are deployed
export const functions = getFunctions(app, 'us-central1');
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;
